<template>
   <div class="contents-goods-left">
        <div class="swiper-container-thumb">
          
            <div class="swiper-wrapper">
                
                <div class="swiper-slide" v-for="(Swiper,indexw) in goodsSwiper" :key="indexw">
                    <img v-if="Swiper.type=='pic'" :src="Swiper.url">
                    <video v-if="Swiper.type=='mp4'" :src="Swiper.url" controls="controls" :poster="Swiper.poster">                   
                    </video>
                </div>
            </div>
            <div class="swiper-pagination"></div> 
        </div>
        <div class="swiper-line" >
            <div class="swiper-button-next swiper-button-white swiper-button-next-goods" v-if="goodsSwiper.length>4"  ></div>
            <div class="swiper-container" :class="{'swiperlenght1':goodsSwiper.length==1,'swiperlenght2':goodsSwiper.length==2,'swiperlenght3':goodsSwiper.length==3}">                       
                <div class="swiper-wrapper" >
                    <div class="swiper-slide" v-for="(Swiper,indexw) in goodsSwiper" :key="indexw">
                        <img v-if="Swiper.type=='pic'" :src="Swiper.url">                        
                        <img v-if="Swiper.type=='mp4'" :src="Swiper.poster">                     
                    </div>
                </div>                                                
            </div>
            <div class="swiper-button-prev swiper-button-white swiper-button-prev-goods" v-if="goodsSwiper.length>4"></div>         
        </div> 
    </div>
</template>
<script>
    //引用swiper
    import Swiper from "swiper";
    //引用swiper样式
   	import 'swiper/swiper.min.css'; 
    export default {
    data(){            
            return {
                'swiperUrl':"/goods/swiper",
                'goodsSwiper':""
            }
    },
    // props: ['goodsSwiper'],
    mounted() {
        //组件挂载完毕后初始化Swiper
        //this.getgoodsSwiper();
        
    },
     watch:{
        goodsSwiper(val,oldval){
            if(val!=""){
                 this.$nextTick(function () {
                        this.getSwiper();
                        this.getthumb(); 
                     })
            }
        }
    },
    methods:{
            getSwiper(){
                var mlength = this.goodsSwiper.length;
                if(mlength>4){
                    mlength=4;
                }
                this.galleryThumbs = new Swiper('.swiper-container', {
                    spaceBetween: 10,
                    slidesPerView: mlength,
                    watchSlidesVisibility: true,
                    watchSlidesProgress: true,
                    navigation: {
                        nextEl: '.swiper-button-next-goods',
                        prevEl: '.swiper-button-prev-goods',
                    },
                });                
            },
            getthumb(){
                 //if(this.goodsSwiper.length>4){
                    this.swiper2 = new Swiper(".swiper-container-thumb", {
                    spaceBetween: 10,           
                    thumbs: {
                        swiper: this.galleryThumbs,
                    },
                    });
                //  }else{
                //     this.swiper2 = new Swiper('.swiper-container-thumb', {
                //     spaceBetween: 10,
                //     slidesPerView: 1,
                //     loop:true,
                //     autoplay:true,
                //     watchSlidesVisibility: true,
                //     watchSlidesProgress: true,
                //     navigation: {
                //         nextEl: '.swiper-button-next',
                //         prevEl: '.swiper-button-prev',
                //     },
                //     })
                //  }
                
            },
               /**
             * 
             * 获取切换图 
             */
            getgoodsSwiper(swiperdata){
                this.goodsSwiper =swiperdata; 
            },            
        },
}
</script>

<style  scoped>
    .contents-goods-left{
        overflow: hidden;
        width: 525px;
    }
    .swiper-slide{
        height: 85px !important;
        overflow: hidden !important;
        background-color: #fff !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;

    }
    .swiper-slide img{
        max-width: 100% !important;
        max-height: 90% !important;        
    }
    .swiper-slide video{
        max-width: 100% !important;        
    }
    .swiper-container-thumb{
        margin-bottom: 20px !important;
        position: relative !important;
    }

    .swiper-container-thumb .swiper-slide img{
        max-height: 100% !important;
    }
    .swiper-wrapper{
        background-color: #f3f5f7 !important ;
    }
    .swiper-button-prev.swiper-button-white, .swiper-button-next.swiper-button-white{
        --swiper-navigation-color: #d8dadb !important;/* 单独设置按钮颜色 */
        --swiper-navigation-size: 30px !important;/* 设置按钮大小 */
        }
    .swiper-button-prev.swiper-button-disabled, .swiper-button-next.swiper-button-disabled{
        opacity:1;
    }
    .swiper-container{
        width: 85% !important;
    }
    .swiperlenght1{
        width: 20% !important;
    }

    .swiperlenght2{
        width: 40% !important;
    }
    .swiperlenght3{
        width: 60% !important;
    }
     
    .swiper-line{
        position: relative !important;
    }
    .swiper-slide-thumb-active{
        border:solid 1px #2655ae !important;
        box-sizing: border-box !important;
    }
    .swiper-container-thumb .swiper-slide{
         width:525px !important;
        height: 429px !important;
        background-color: #f3f5f7 !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
    }
</style>


// WEBPACK FOOTER //
// src/components/goods/GoodsSwiper.vue